/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AuthLoginLocalCreatePayload,
  OnboardCheckEmailCreatePayload,
  OnboardCheckPhoneNumberCreatePayload,
  OnboardCheckProgressCreatePayload,
  OnboardCreatePayload,
  OnboardIdentityCheckProgressCreatePayload,
  OnboardVerifyPhoneNumberCreatePayload,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Agent<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Auth
   * @name AuthLoginLocalCreate
   * @summary Auth Agent
   * @request POST:/agent/auth/login-local
   * @response `200` `void` OK
   * @response `default` `void` Error message
   */
  authLoginLocalCreate = (data: AuthLoginLocalCreatePayload, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/agent/auth/login-local`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Onboard
   * @name OnboardCheckEmailCreate
   * @summary Check if email is already registered
   * @request POST:/agent/onboard/check-email
   * @response `200` `{ redirect?: boolean }` OK
   * @response `default` `void` Error message
   */
  onboardCheckEmailCreate = (data: OnboardCheckEmailCreatePayload, params: RequestParams = {}) =>
    this.request<{ redirect?: boolean }, void>({
      path: `/agent/onboard/check-email`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Onboard
   * @name OnboardCheckProgressCreate
   * @summary Check if onboard process is completed
   * @request POST:/agent/onboard/check-progress
   * @response `200` `{ redirect?: boolean }` OK
   * @response `default` `void` Error message
   */
  onboardCheckProgressCreate = (data: OnboardCheckProgressCreatePayload, params: RequestParams = {}) =>
    this.request<{ redirect?: boolean }, void>({
      path: `/agent/onboard/check-progress`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Onboard
   * @name OnboardCheckPhoneNumberCreate
   * @summary Phone number check
   * @request POST:/agent/onboard/check-phone-number
   * @response `200` `void` Phone number check
   * @response `default` `void` Error message
   */
  onboardCheckPhoneNumberCreate = (data: OnboardCheckPhoneNumberCreatePayload, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/agent/onboard/check-phone-number`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Onboard
   * @name OnboardIdentityCheckProgressCreate
   * @summary Check if user has confirmed identity
   * @request POST:/agent/onboard/identity-check-progress
   * @response `200` `{ status?: boolean }` OK
   * @response `default` `void` Error message
   */
  onboardIdentityCheckProgressCreate = (data: OnboardIdentityCheckProgressCreatePayload, params: RequestParams = {}) =>
    this.request<{ status?: boolean }, void>({
      path: `/agent/onboard/identity-check-progress`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Onboard
   * @name OnboardCreate
   * @summary Onboard new agent and company
   * @request POST:/agent/onboard
   * @response `200` `void` Success
   * @response `default` `void` Error message
   */
  onboardCreate = (data: OnboardCreatePayload, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/agent/onboard`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Onboard
   * @name OnboardVerifyPhoneNumberCreate
   * @summary Send verification code to phone number
   * @request POST:/agent/onboard/verify-phone-number
   * @response `200` `void` Verification
   * @response `default` `void` Error message
   */
  onboardVerifyPhoneNumberCreate = (data: OnboardVerifyPhoneNumberCreatePayload, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/agent/onboard/verify-phone-number`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
